import axios from '../config/axios'

export const getAllPublishedInsights = async (filter: { [key: string]: any }) => {
    try {
        const response = await axios.get("/api/insight", {
            params: filter
        });
        return {
            data: response.data.data,
            pagination: response.data.pagination
        };
    } catch (error: any) {
        throw error.response?.data || error;
    }
};

export const createInsight = async (data: any) => {
    try {
        const response = await axios.post("/api/admin/insight", data);
        return response.data;
    } catch (error: any) {
        throw error.response?.data || error;
    }
};

export const getAllInsights = async (filter: { [key: string]: any }) => {
    try {
        const response = await axios.get("/api/admin/insight", {
            params: filter
        });
        return {
            data: response.data.data,
            pagination: response.data.pagination
        };
    } catch (error: any) {
        throw error.response?.data || error;
    }
};

export const updateInsight = async (slug: string, data: any) => {
    try {
        const response = await axios.put(`/api/admin/insight/${slug}`, data);
        return response.data;
    } catch (error: any) {
        throw error.response?.data || error;
    }
};

export const deleteInsight = async (slug: string) => {
    try {
        const response = await axios.delete(`/api/admin/insight/${slug}`);
        return response.data;
    } catch (error: any) {
        throw error.response?.data || error;
    }
};

export const getInsightBySlug = async (slug: string) => {
    try {
        const response = await axios.get(`/api/insight/${slug}`);
        return response.data;
    } catch (error: any) {
        throw error.response?.data || error;
    }
};

export const updateInsightStatus = async (slug: string, status: string) => {
    try {
        const response = await axios.put(`/api/admin/insight/${slug}/status`, { status });
        return response.data;
    } catch (error: any) {
        throw error.response?.data || error;
    }
};